// src/index.ts
export * from "@wallet-standard/core";

// src/detect.ts
var REQUIRED_FEATURES = [
  "standard:connect",
  "standard:events"
];
function isWalletWithSuiFeatures(wallet, features = []) {
  return [...REQUIRED_FEATURES, ...features].every((feature) => feature in wallet.features);
}
function isWalletWithRequiredFeatureSet(wallet, additionalFeatures = []) {
  return [...REQUIRED_FEATURES, ...additionalFeatures].every(
    (feature) => feature in wallet.features
  );
}

// src/chains.ts
var SUI_DEVNET_CHAIN = "sui:devnet";
var SUI_TESTNET_CHAIN = "sui:testnet";
var SUI_LOCALNET_CHAIN = "sui:localnet";
var SUI_MAINNET_CHAIN = "sui:mainnet";
var SUI_CHAINS = [
  SUI_DEVNET_CHAIN,
  SUI_TESTNET_CHAIN,
  SUI_LOCALNET_CHAIN,
  SUI_MAINNET_CHAIN
];
export {
  SUI_CHAINS,
  SUI_DEVNET_CHAIN,
  SUI_LOCALNET_CHAIN,
  SUI_MAINNET_CHAIN,
  SUI_TESTNET_CHAIN,
  isWalletWithRequiredFeatureSet,
  isWalletWithSuiFeatures
};
//# sourceMappingURL=index.mjs.map